import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { formatPrice } from '../utils/format';
import { productOrderUrl } from '../utils/whatsapp';
import { trackAddToCart } from '../utils/metaPixel';
import type { Product } from '../types/catalog';
interface ProductCardProps {
  product: Product;
  onOpen: (product: Product) => void;
}
export function ProductCard({
  product,
  onOpen
}: ProductCardProps) {
  return <article className="flex flex-col" data-id="element-69" data-mp="kbtpkuhgcdl1">
      <button type="button" onClick={() => onOpen(product)} className="group relative block overflow-hidden rounded-2xl bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-cobalt" aria-label={`Ver ficha de ${product.name}`} data-id="element-70" data-mp="kexxo2y1ftgz">
        <img src={product.image} alt={`Frasco de ${product.name}`} className="aspect-[4/5] w-full object-contain transition-transform duration-300 ease-smooth group-hover:scale-[1.04]" loading="lazy" data-id="element-71" data-mp="ybl6b2zcs82q" />
        <span className="absolute left-3 top-3 rounded-full bg-navy px-3 py-1 text-[10px] font-semibold uppercase tracking-wide text-ivory" data-id="element-72" data-mp="3lrdmjktsugf4">
          {product.family}
        </span>
      </button>

      <h3 className="mt-4 font-display text-lg font-bold leading-tight text-navy" data-id="element-73" data-mp="3cy0ltwphuaih">
        <button type="button" onClick={() => onOpen(product)} className="text-left transition-colors duration-200 ease-smooth hover:text-cobalt" data-id="element-74" data-mp="37zpdxrirea2w">
          {product.name}
        </button>
      </h3>

      <p className="mt-1.5 text-[10px] font-bold uppercase tracking-wide text-cobalt" data-id="element-75" data-mp="4k1vbalajhcd">
        Precio de lanzamiento
      </p>
      <p className="mt-1 flex items-baseline gap-2" data-id="element-76" data-mp="3vr4lpztb1jlj">
        <span className="font-display text-lg font-extrabold text-navy" data-id="element-77" data-mp="3qqq9s6ol1pi8">
          {formatPrice(product.price)}
        </span>
        {product.compareAtPrice && <span className="text-sm text-mute line-through" data-id="element-78" data-mp="2farw1pigmfao">
            {formatPrice(product.compareAtPrice)}
          </span>}
      </p>

      <a href={productOrderUrl(product.name)} target="_blank" rel="noreferrer" onClick={() => trackAddToCart({
      contentName: product.name,
      contentId: product.slug,
      value: product.price
    })} className="mt-3 flex items-center justify-center gap-2 rounded-full bg-lime px-4 py-3 text-[11px] font-bold uppercase tracking-wide text-navy transition-colors duration-200 ease-smooth hover:bg-lime-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-cobalt" data-id="element-79" data-mp="2gt09ryls3ijt">
        <MessageCircleIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-80" data-mp="1p1azinmng0r2" />
        Pedir por WhatsApp
      </a>
    </article>;
}